var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlimatLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "53.44mm",
    height: "28.4mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5344 2840",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n                     \n                        .str0 {stroke:#FEFEFE;stroke-width:17.64;stroke-linecap:round;stroke-linejoin:bevel}\n                        .fil2 {fill:none}\n                        .fil5 {fill:#FEFEFE}\n                        .fil4 {fill:#EF7F1A}\n                        .fil6 {fill:#86C6ED}\n                        .fil1 {fill:#0060AA}\n                        .fil3 {fill:#FEFEFE;fill-rule:nonzero}\n                        .fil0 {fill:#FEFEFE;fill-rule:nonzero}\n                        \n                  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_303066008"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M218 2811l-126 0 0 -863 126 0 0 418 453 -418 174 0 -389 349 400 514 -164 0 -327 -433 -147 130 0 303zm910 -760l0 527c0,67 -12,119 -36,156 -23,37 -53,61 -89,74 -37,13 -78,19 -124,19l0 -104c51,0 85,-12 102,-38 18,-25 27,-61 27,-108l0 -629 625 0 0 863 -126 0 0 -760 -379 0zm823 594l2 0 468 -697 150 0 0 863 -122 0 0 -697 -3 0 -476 697 -142 0 0 -863 123 0 0 697zm1591 166l0 -510c0,-49 1,-93 1,-132 1,-39 2,-66 2,-83l-3 0 -263 725 -125 0 -263 -724 -3 0c2,0 3,72 3,214l0 510 -122 0 0 -863 181 0 267 729 3 0 265 -729 179 0 0 863 -122 0zm457 -251l-97 251 -131 0 352 -863 143 0 339 863 -138 0 -93 -251 -375 0zm330 -104l-138 -380 -3 0 -150 380 291 0zm168 -508l759 0 0 103 -317 0 0 760 -126 0 0 -760 -316 0 0 -103z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "0,1 1664,1 1664,1667 0,1667 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 855,
    y1: 140,
    x2: 855,
    y2: 1538
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1102,
    y1: 271,
    x2: 857,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 609,
    y1: 271,
    x2: 853,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1102,
    y1: 1386,
    x2: 857,
    y2: 1228
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 609,
    y1: 1386,
    x2: 853,
    y2: 1228
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 250,
    y1: 489,
    x2: 1460,
    y2: 1189
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 486,
    y1: 341,
    x2: 501,
    y2: 633
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 240,
    y1: 769,
    x2: 500,
    y2: 636
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1452,
    y1: 899,
    x2: 1193,
    y2: 1032
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1206,
    y1: 1326,
    x2: 1191,
    y2: 1035
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 250,
    y1: 1189,
    x2: 1461,
    y2: 490
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 240,
    y1: 910,
    x2: 500,
    y2: 1042
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 486,
    y1: 1337,
    x2: 502,
    y2: 1045
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1206,
    y1: 352,
    x2: 1191,
    y2: 643
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil2",
    x1: 1452,
    y1: 779,
    x2: 1193,
    y2: 646
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "890,140 890,1538 820,1538 820,140 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1121,300 876,459 838,400 1082,241 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "628,241 872,400 834,459 589,300 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1082,1416 838,1257 876,1198 1121,1357 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "589,1357 834,1198 872,1257 628,1416 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "267,459 1478,1158 1443,1219 232,520 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "522,340 537,631 466,634 451,343 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "224,737 484,605 515,667 256,800 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1468,931 1209,1063 1177,1000 1436,868 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1171,1328 1155,1037 1226,1033 1241,1324 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "232,1158 1443,459 1478,520 267,1219 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "256,878 516,1011 484,1073 224,941 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "451,1335 466,1044 537,1047 522,1338 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1241,354 1226,645 1156,641 1171,350 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3",
    points: "1436,810 1177,678 1209,615 1468,748 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "1838,2 3502,2 3502,1668 1838,1668 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "2670,136 2824,427 3129,303 3060,625 3373,726 3113,928 3288,1207 2959,1195 2914,1521 2670,1300 2426,1521 2381,1195 2052,1207 2226,928 1967,726 2280,625 2211,303 2516,427 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M2675 445c222,0 403,180 403,403 0,222 -181,402 -403,402 -222,0 -402,-180 -402,-402 0,-223 180,-403 402,-403z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "3680,1 5331,1 5331,1667 3680,1667 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M4861 764c68,81 108,186 108,300 0,257 -207,466 -463,466 -256,0 -464,-209 -464,-466 0,-114 41,-219 108,-300l-2 0c175,-202 292,-411 358,-627 66,222 175,433 358,627l-3 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "3683,1579 5341,1579 5341,1626 3683,1626 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3683 1482c553,0 1106,0 1659,0 0,14 0,29 0,43 -553,0 -1106,0 -1659,0 0,-14 0,-29 0,-43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3683 1385c553,0 1106,0 1659,0 0,13 0,26 0,39 -553,0 -1106,0 -1659,0 0,-13 0,-26 0,-39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3684 1288c553,0 1106,0 1658,0 0,12 0,23 0,35 -552,0 -1105,0 -1658,0 0,-12 0,-23 0,-35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3684 1191c553,0 1106,0 1659,0 0,10 0,21 0,31 -553,0 -1106,0 -1659,0 0,-10 0,-21 0,-31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3684 1094c553,0 1106,0 1659,0 0,9 0,18 0,27 -553,0 -1106,0 -1659,0 0,-9 0,-18 0,-27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3685 997c553,0 1105,0 1658,0 0,8 0,15 0,23 -553,0 -1105,0 -1658,0 0,-8 0,-15 0,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M3685 900c553,0 1106,0 1659,0 0,6 0,13 0,19 -553,0 -1106,0 -1659,0 0,-6 0,-13 0,-19z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "3685,803 5344,803 5344,818 3685,818 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlimatLogo);
export default __webpack_public_path__ + "static/media/klimat-logo.a77aba53.svg";
export { ForwardRef as ReactComponent };